// Generated by packages/assets/scripts/generate.ts. Do not edit; edit the sources and run pnpm generate.
import type { AtlasDef } from "../src/types.ts";

export const ATLAS = {
  "v": 1,
  "unit": 8,
  "width": 2048,
  "height": 256,
  "channels": [
    "tone",
    "line",
    "height"
  ],
  "render": {
    "font": "Arial Black.ttf"
  },
  "sprites": {
    "banner-flag": {
      "x": 1736,
      "y": 4,
      "w": 106,
      "h": 81,
      "ax": -7,
      "ay": 190
    },
    "banner-pole": {
      "x": 4,
      "y": 4,
      "w": 14,
      "h": 192,
      "ax": 7,
      "ay": 192
    },
    "digit-1": {
      "x": 1308,
      "y": 4,
      "w": 62,
      "h": 104,
      "ax": 37,
      "ay": 48
    },
    "digit-1-halo": {
      "x": 361,
      "y": 4,
      "w": 86,
      "h": 128,
      "ax": 49,
      "ay": 60
    },
    "digit-2": {
      "x": 1374,
      "y": 4,
      "w": 86,
      "h": 104,
      "ax": 44,
      "ay": 48
    },
    "digit-2-halo": {
      "x": 451,
      "y": 4,
      "w": 110,
      "h": 128,
      "ax": 56,
      "ay": 60
    },
    "digit-3": {
      "x": 1041,
      "y": 4,
      "w": 86,
      "h": 105,
      "ax": 43,
      "ay": 48
    },
    "digit-3-halo": {
      "x": 22,
      "y": 4,
      "w": 110,
      "h": 129,
      "ax": 55,
      "ay": 60
    },
    "digit-4": {
      "x": 1464,
      "y": 4,
      "w": 90,
      "h": 104,
      "ax": 45,
      "ay": 48
    },
    "digit-4-halo": {
      "x": 565,
      "y": 4,
      "w": 114,
      "h": 128,
      "ax": 57,
      "ay": 60
    },
    "digit-5": {
      "x": 1558,
      "y": 4,
      "w": 86,
      "h": 103,
      "ax": 43,
      "ay": 46
    },
    "digit-5-halo": {
      "x": 815,
      "y": 4,
      "w": 110,
      "h": 127,
      "ax": 55,
      "ay": 58
    },
    "digit-6": {
      "x": 1131,
      "y": 4,
      "w": 85,
      "h": 105,
      "ax": 42,
      "ay": 48
    },
    "digit-6-halo": {
      "x": 136,
      "y": 4,
      "w": 109,
      "h": 129,
      "ax": 54,
      "ay": 60
    },
    "digit-7": {
      "x": 1648,
      "y": 4,
      "w": 84,
      "h": 102,
      "ax": 42,
      "ay": 46
    },
    "digit-7-halo": {
      "x": 929,
      "y": 4,
      "w": 108,
      "h": 126,
      "ax": 54,
      "ay": 58
    },
    "digit-8": {
      "x": 1220,
      "y": 4,
      "w": 84,
      "h": 105,
      "ax": 42,
      "ay": 48
    },
    "digit-8-halo": {
      "x": 249,
      "y": 4,
      "w": 108,
      "h": 129,
      "ax": 54,
      "ay": 60
    },
    "smoke-1": {
      "x": 1944,
      "y": 4,
      "w": 26,
      "h": 26,
      "ax": 13,
      "ay": 13
    },
    "smoke-2": {
      "x": 1902,
      "y": 4,
      "w": 38,
      "h": 38,
      "ax": 19,
      "ay": 19
    },
    "smoke-3": {
      "x": 1846,
      "y": 4,
      "w": 52,
      "h": 52,
      "ax": 26,
      "ay": 26
    },
    "wrong-x": {
      "x": 683,
      "y": 4,
      "w": 128,
      "h": 128,
      "ax": 64,
      "ay": 64
    }
  }
} as const satisfies AtlasDef;

export type SpriteName = keyof typeof ATLAS.sprites;
